<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <shipping-label-modal
      :show-modal="showModal"
      @close-modal="$emit('close-modal')"
      :booking="booking"
      :action="action"
    >
      <div class="flex items-center gap-2 pb-4">
        <span
          ><svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00014 0.320312C3.75774 0.320312 0.319336 3.75871 0.319336 8.00031C0.319231 9.009 0.517829 10.0078 0.903788 10.9398C1.28975 11.8717 1.85551 12.7184 2.56876 13.4317C3.282 14.1449 4.12877 14.7107 5.0607 15.0967C5.99262 15.4826 6.99145 15.6812 8.00014 15.6811C12.2409 15.6811 15.6801 12.2427 15.6801 8.00031C15.6801 3.75871 12.2409 0.320312 8.00014 0.320312ZM8.71694 3.09311C9.46574 3.09311 9.68574 3.52751 9.68574 4.02431C9.68574 4.64431 9.18974 5.21791 8.34254 5.21791C7.63374 5.21791 7.29614 4.86191 7.31694 4.27231C7.31694 3.77551 7.73214 3.09311 8.71694 3.09311ZM6.79854 12.6003C6.28654 12.6003 5.91294 12.2891 6.27054 10.9251L6.85694 8.50511C6.95854 8.11791 6.97534 7.96271 6.85694 7.96271C6.70414 7.96271 6.03934 8.22991 5.64734 8.49391L5.39214 8.07551C6.63614 7.03631 8.06653 6.42671 8.67853 6.42671C9.19053 6.42671 9.27534 7.03151 9.02013 7.96271L8.34814 10.5067C8.22894 10.9563 8.28014 11.1115 8.39933 11.1115C8.55293 11.1115 9.05534 10.9259 9.54974 10.5363L9.83934 10.9251C8.62893 12.1347 7.30974 12.6003 6.79854 12.6003Z"
              fill="#C2C7D6"
            />
          </svg>
        </span>
        You have initiated a return shipment action for the shipment below. Click next to
        continue
      </div>
    </shipping-label-modal>
    <return-details-modal
      :show-modal="showDetails"
      @close-modal="showDetails = false"
      :booking="booking"
      :action="action"
      @hide-return="showDetails = false; $emit('hide-return')"
    />
  </modal>
</template>

<script>
import ShippingLabelModal from "./ShippingLabelModal.vue";
import ReturnDetailsModal from "./ReturnDetailsModal.vue";
export default {
  components: {
    ReturnDetailsModal,
    ShippingLabelModal,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    action() {
      this.showDetails = true;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}
p {
  text-align: left;
}
</style>
